import { style } from 'styled-system';

const cursor = style({
  prop: 'cursor',
  cssProperty: 'cursor'
});

export default cursor;
